import type {Pointer} from '@wix/document-services-types'

function pluginFn(siteAPI, compLayoutRelativeToStructure, compProperties, compPointer: Pointer) {
    const isVertical = compProperties?.verticalText
    return isVertical
        ? {
              width: siteAPI.getSiteMeasureMap().minWidth[compPointer.id]
          }
        : {
              height: siteAPI.getSiteMeasureMap().minHeight[compPointer.id]
          }
}

export default pluginFn
